import type { JSX } from 'react';
import { Outlet } from 'react-router-dom';

export function RefereeAppLayout(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="border-b bg-background px-4 py-3">
        <span className="text-lg font-semibold">CareerVerification</span>
      </header>
      <main className="mx-auto w-full max-w-2xl flex-1 px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
